<script lang="ts">
    import { Link, useNavigate, useParams } from "svelte-navigator";
    import type { IRoute, IRouteGroup } from "../../../settings/settings";
    import { mediaQuery, user } from "../../../store/stores";

    export let routesGroup: IRouteGroup;
    export let onClickCallback: () => any;
    const params = useParams();
    const navigate = useNavigate();
    let allowedRoutes = [];

    console.log(routesGroup);

    user.subscribe((store) => {
        allowedRoutes = routesGroup.routes.filter((route) => {
            return (
                route.requiredPermissions.filter(
                    (permission) => [] // store.extendedUserData.permissions.includes(permission)
                ).length > 0 || route.requiredPermissions.length === 0
            );
        });
    });

    $: isActive = (routeObject: IRoute) => {
        if (($params["*"] as unknown as string) === routeObject.route) {
            return "is-active";
        }
        return "";
    };
</script>

{#if allowedRoutes.length > 0}
    <button class="menu-label gradient-left">{routesGroup.name}</button>
    <ul class="menu-list">
        {#each allowedRoutes as { route, name, requiredPermissions, subitems }}
            <li>
                {#if $mediaQuery.mql.matches}
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <button
                        on:click={() => {
                            onClickCallback();
                            navigate(route);
                        }}
                        class={isActive({
                            route,
                            name,
                            requiredPermissions,
                        })}>{name}</button
                    >
                {:else}
                    <button
                        on:click={() => {
                            onClickCallback();
                            navigate(route);
                        }}
                        class={isActive({
                            route,
                            name,
                            requiredPermissions,
                        }) + " item"}
                    >
                        {name}
                    </button>
                {/if}
                {#if subitems?.length}
                    <ul>
                        {#each subitems as { route, name, requiredPermissions }}
                            <li>
                                <!-- svelte-ignore a11y-missing-attribute -->
                                <button
                                    on:click={() => {
                                        onClickCallback();
                                        navigate(route);
                                    }}
                                    class={isActive({
                                        route,
                                        name,
                                        requiredPermissions,
                                        subitems,
                                    }) + " item"}>{name}</button
                                >
                            </li>
                        {/each}
                    </ul>
                {/if}
            </li>
        {/each}
    </ul>
{/if}

<style>
    button {
        width: 100%;
        text-align: left;
        margin-top: 0 !important;
        margin-bottom: 1em;
        border: 0 !important;
        padding: 10px 20px;
    }
    .item {
        background-color: rgb(230, 230, 230);
    }

    .item:hover {
        cursor: pointer;
        box-shadow: 0 0 0 1px #14acab;
    }

    button.is-active {
    }
</style>
